module.exports = __webpack_public_path__ + "eadca6caa1ad5e2e391002f789f6cb4c.svg";